import { ChangeEvent, FormEvent, useState } from "react";
import { Form } from "./contactoM";
import * as contactoService from "./contactoService";
import { toast } from "react-toastify";
import styles from "./contacto.module.css"
import { Link } from "react-router-dom"

type InputChange = ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

export const Contacto = () => {
  const [form, setForm] = useState<Form>({
    name: "",
    number: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e: InputChange) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await contactoService.postForm(form);
    toast.success("Mensaje enviado");
  };

  return (
    <div className={styles.main}>

       <div className={styles.menu}>
                <div className={styles.innermenu}>
                    <div className={styles.logo}></div>
                    
                    <div className={styles.btns}>
                        <Link to="/"><button id={styles.homebtn}>Home</button></Link>
                        <Link to="/contacto"><button id={styles.contactbtn}>Contacto</button></Link>
                        
                    </div>
                </div>

                <div className={styles.headerbottom}>
                    <p id={styles.message}>Despachos con normalidad</p>
                </div>
 
            </div>

      <div className={styles.contacto}>
        <div className={styles.contactbox}>
          <h1>Envianos tus consultas</h1>

          <form onSubmit={handleSubmit}>
            <input
              onChange={handleInputChange}
              type="text"
              name="name"
              placeholder="Nombre y apellido"
            />
            <input
              onChange={handleInputChange}
              type="text"
              name="email"
              placeholder="Correo electronico"
            />
            <input
              onChange={handleInputChange}
              type="text"
              name="number"
              placeholder="Numero telefonico"
            />
            <textarea
              onChange={handleInputChange}
              name="message"
              placeholder="Consulta"
            />
            <button>Enviar</button>
          </form>
        </div>
      </div>
    </div>
  );
};
 